<template>
    <div class="col-span-full">
        <slot name="label">
            <label v-if="label" class="block text-sm font-medium text-gray-700 mb-1" v-text="label" :for="name && `field-${name}`"></label>
        </slot>

        <slot :id="name && `field-${name}`"></slot>

        <slot name="hint">
            <ui-hint :error="error" :warning="warning" :info="info"></ui-hint>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        name: String,
        error: String,
        warning: String,
        info: String,

        // Ignored props.
        type: null,
        required: null,
        value: null,
        field: null,
        row: null,
        options: null,
        multiple: null,
        preview: null,
        text: null,
    },
}
</script>
